// src/components/Header/TopBar.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

const TopBar = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const lng = event.target.value;
    i18n.changeLanguage(lng);
  };

  return (
    <div className="bg-gradient-to-r from-[#4f837d] to-[#3a645f] text-white text-sm py-2 px-4 flex justify-between items-center shadow-md">
      <motion.div 
        className="flex items-center"
        whileHover={{ scale: 1.02 }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" viewBox="0 0 20 20" fill="currentColor">
          <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
          <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
        </svg>
        <a 
          href="mailto:Sales@takeoportunit.com" 
          className="hover:text-white/70 transition-colors"
        >
          Sales@takeoportunit.com
        </a>
      </motion.div>

      <div className="flex items-center space-x-4">
        <select
          value={i18n.language}
          onChange={changeLanguage}
          className="bg-transparent border-none text-white cursor-pointer focus:outline-none focus:ring-1 focus:ring-white/50 rounded px-1 py-0.5"
          aria-label="Sélectionner la langue"
        >
          <option value="fr" className="text-black">Français</option>
          <option value="en" className="text-black">English</option>
        </select>

        <motion.a 
          href="https://www.facebook.com/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Facebook"
          whileHover={{ scale: 1.2 }}
          className="text-white hover:text-white/70 transition-colors"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
            <path d="M9.188 24v-8.112H6.06V12.5h3.127V9.94c0-3.092 1.834-4.802 4.703-4.802 1.375 0 2.597.096 2.946.14v3.41h-2.02c-1.597 0-1.904.756-1.904 1.87v2.46h3.805l-.5 3.39h-3.305V24z"/>
          </svg>
        </motion.a>
        
        <motion.a 
          href="https://wa.me/22666390000" 
          target="_blank"
          rel="noopener noreferrer"
          aria-label="WhatsApp"
          whileHover={{ scale: 1.2 }}
          className="text-white hover:text-white/70 transition-colors"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
          </svg>
        </motion.a>
      </div>
    </div>
  );
};

export default TopBar;